import fgInput from './components/Inputs/formGroupInput.vue'
import DropDown from './components/Dropdown.vue'
import Checkbox from './components/Inputs/Checkbox.vue'
import Table from './hotfixes'
import {TableColumn, Radio, Select, OptionGroup, Option, Input, InputNumber, Tooltip, Popover, Badge, Tabs, TabPane, Switch, Transfer, Collapse, CollapseItem, Carousel, CarouselItem} from 'element-ui'

/**
 * You can register global components here and use them as a plugin in your main Vue instance
 * Ideally, only small components that are re-used many times across your application should be registered here.
 * For plugins and bigger components local registration is preferable because it will allow you to do code splitting easier :)
 */

const GlobalComponents = {
  install (Vue) {
    Vue.component(fgInput.name, fgInput)
    Vue.component(DropDown.name, DropDown)
    Vue.component(Checkbox.name, Checkbox)
    Vue.component(Radio.name, Radio)
    Vue.component(Table.name, Table)
    Vue.component(TableColumn.name, TableColumn)
    Vue.component(Select.name, Select)
    Vue.component(OptionGroup.name, OptionGroup)
    Vue.component(Option.name, Option)
    Vue.component(Input.name, Input)
    Vue.component(InputNumber.name, InputNumber)
    Vue.component(Tooltip.name, Tooltip)
    Vue.component(Popover.name, Popover)
    Vue.component(Badge.name, Badge)
    Vue.component(Tabs.name, Tabs)
    Vue.component(TabPane.name, TabPane)
    Vue.component(Switch.name, Switch)
    Vue.component(Transfer.name, Transfer)
    Vue.component(Collapse.name, Collapse)
    Vue.component(CollapseItem.name, CollapseItem)
    Vue.component(CarouselItem.name, CarouselItem)
    Vue.component(Carousel.name, Carousel)
  }
}

export default GlobalComponents
